import createAction from '../../../utils/redux-helpers/createAction';

const handler = (state, { id, value }) =>
  state.withMutations(next =>
    next
      .setIn(['products', 'items', id, 'currentQuantity'], value)
      .setIn(
        ['products', 'items', id, 'activeOption'],
        state
          .getIn(['products', 'items', id, 'productPrices'])
          .findIndex(item => item.get('quantity') === value),
      )
      .update('orderList', list => {
        if (list.includes(id) && value > 0) {
          return list;
        }
        if (!list.includes(id) && value > 0) {
          return list.push(id);
        }
        if (value === 0) {
          return list.filter(item => item !== id);
        }
        return list;
      }),
  );

export const setProductDropdownQuantity = createAction({
  action: ['setProductDropdownQuantity', 'id', 'value'],
  handler,
});
